import { defineMessages } from 'react-intl'

export default defineMessages({
  allowLocationTitle: {
    id: 'src.components.maps.allowLocationTitle',
    defaultMessage: 'Location could not be found',
  },
  allowLocationMessage: {
    id: 'src.components.maps.allowLocationMessage',
    defaultMessage:
      "Please allow location services in your browser's and device's settings. Or input your desired location in the search field.",
  },
  noResultsFoundMessage: {
    id: 'src.components.maps.noResultsFoundMessage',
    defaultMessage: 'Unfortunately, there are no open places found around the requested location.',
  },
  noLocationFoundMessage: {
    id: 'src.components.maps.noLocationFoundMessage',
    defaultMessage: 'Sorry, location could not be found.',
  },
  listView: {
    id: 'src.components.maps.listView',
    defaultMessage: 'View List',
  },
  mapView: {
    id: 'src.components.maps.mapView',
    defaultMessage: 'View Map',
  },
  mapFindLocationFieldPlaceholder: {
    id: 'src.components.maps.findLocationFieldPlaceholder',
    defaultMessage: 'Current Location',
  },
})
